import Logo from '../Logo/Logo'

import styles from './Header.css'

interface IProps {
  readonly children?: unknown
}

export default function Header (props: IProps): HTMLElement {
  return (
    <div className={ styles.header }>
      <Logo />
      { props.children }
    </div>
  )
}
